import { InstagramIcon, LinkedinIcon, FacebookIcon, TiktokIcon } from "../lib/icons";
import { SOCIAL_LINKS, SOCIAL_LINKS_LIVE } from "../data/content";

const ICONS = { instagram: InstagramIcon, tiktok: TiktokIcon, linkedin: LinkedinIcon, facebook: FacebookIcon };

/** Row of circular social buttons. `tone="ink"` for light backgrounds. */
export const SocialLinks = ({ className = "", size = "md" }) => {
  if (!SOCIAL_LINKS_LIVE) return null;
  const dim = size === "sm" ? "h-9 w-9" : "h-10 w-10";
  const icon = size === "sm" ? "h-4 w-4" : "h-[18px] w-[18px]";
  return (
    <ul className={`flex flex-wrap items-center gap-2.5 ${className}`} data-testid="social-links">
      {SOCIAL_LINKS.map((s) => {
        const Icon = ICONS[s.id];
        return (
          <li key={s.id}>
            <a
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`My Rich Aunt on ${s.label}`}
              data-testid={`social-${s.id}`}
              className={`inline-flex ${dim} items-center justify-center rounded-full border border-ink/20 text-ink transition-colors hover:border-ink hover:bg-ink hover:text-sand`}
            >
              <Icon className={icon} />
            </a>
          </li>
        );
      })}
    </ul>
  );
};
